import { Component } from '@angular/core';
import { NavController } from 'ionic-angular';
import { Storage } from '@ionic/storage';
import { ChatPage } from '../chat/chat';
import { WebServices } from '../../providers/web-services/web-services';
declare var gapi: any;
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {
   public auth2: any;
   loggedInUser:any={firstname:"BK",email:"bishwajit.kolay@abp.in"};
   customMsg:any="";
  constructor(public navCtrl: NavController,private webServices: WebServices,private storage: Storage) {
	  //708352526311-no9t9gqb2bbu33bl3ps7n23bi27epuug.apps.googleusercontent.com
	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const token = urlParams.get('token');
	console.log(token);
  }
  
   ionViewDidLoad() {
	   this.gotoChatbotPage();
   }  
  
  gotoChatbotPage(){
	  //this.googleInit();
	  this.navCtrl.setRoot(ChatPage,{user:this.loggedInUser});
  }
  
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts